@for (item of distributionAssetsForm.controls; track item; let i = $index) {
  <div [formGroup]="item">
    <div class="row d-flex">
      <div class="col col-md-6">
        <pr-input-column
          label="Votre patrimoine global net"
          [derrors]="derrors"
        >
          <mat-select formControlName="fundOrigin">
            @for (option of options; track option) {
              <mat-option [value]="option.value">
                {{ option.label }}
              </mat-option>
            }
          </mat-select>
        </pr-input-column>
      </div>
      <div class="col col-md-3">
        <pr-input-column label="Répartition" [derrors]="derrors">
          <input
            placeholder="Exemple : L5555555L"
            formControlName="distribution"
            type="text"
          />
          <i>%</i>
        </pr-input-column>
      </div>
      <div class="col col-md-3 align-self-center">
        @if (distributionAssetsForm.length > 1) {
          <pr-button-confirm
            class="confirm"
            display="danger"
            clazz="pr-toolbar-button last"
            icon="delete_outline"
            title="Suppression"
            comment="Toute suppression est définitve, les données seront perdues."
            labelConfirm="Supprimer"
            labelCancel="Annuler"
            (onConfirm)="deleteFields(i)"
          >
            Êtes-vous sûr(e) de vouloir supprimer <em></em>
          </pr-button-confirm>
        }
      </div>
    </div>
  </div>
}

<div class="row">
  <div class="col col-md-4">
    <pr-button-add
      type="button"
      display="neutral"
      (click)="addFields()"
      label="Ajouter une provenance de fonds"
      rightIcon="+"
    >
    </pr-button-add>
  </div>
</div>
